module.exports = __webpack_public_path__ + "media/teenage_hangout.2ff58278.ogg";